import { ValidationError } from 'yup';
import { formatFloat, round } from '../../../../../../../helpers';
import { IExpense } from '../expense-form';

// Mirrors the backend rule (expenses.service `validateExpense`, which rejects
// with "subtotal != resource total"): the subtotal must equal the sum of each
// resource's units × unit_price, both rounded to 2 decimals. This surfaces the
// mismatch as an error on the Subtotal field instead of letting it fail as a raw
// server error on save. Computed from `expense_resources` directly (the same
// formula the backend uses), not the derived `resources_total` field.
export function doesSubtotalMatchResourcesTotal(
    value: any,
    context: any,
): boolean | ValidationError {
    const expense = context.parent as IExpense;
    const expenseResources = expense.expense_resources ?? [];

    const resourcesTotal = round(
        expenseResources.reduce((acc, resource) => {
            const unitPrice = !Number.isNaN(Number(resource.unit_price))
                ? Number(resource.unit_price)
                : 0;
            return acc + Number(resource.units) * unitPrice;
        }, 0),
    );

    if (resourcesTotal !== round(Number(value))) {
        return context.createError({
            message: `El subtotal no coincide con el total de productos (${formatFloat(
                resourcesTotal,
            )})`,
        });
    }

    return true;
}
